import {cModalViewDrawCreditProps} from "./HomeTypes";

import HomeRepayCreditModalView from "../../components/modals/HomeRepayCreditModalView";
import HomeRepayCreditModalViewStablecoin from "../../components/modals/HomeRepayCreditModalViewStablecoin";
import HomeRepayCreditModalViewOnRamp from "../../components/modals/HomeRepayCreditModalViewOnRamp";

import HomeDrawCreditModalView from "../../components/modals/HomeDrawCreditModalView";
import HomeDrawCreditModalViewWallet from "../../components/modals/HomeDrawCreditModalViewWallet";
import HomeDrawCreditModalViewOffRamp from "../../components/modals/HomeDrawCreditModalViewOffRamp";

import HomePayFeeModalView from "../../components/modals/HomePayFeeModalView";
import HomePayFeeModalViewStablecoin from "../../components/modals/HomePayFeeModalViewStablecoin";
import HomePayFeeModalViewOnRamp from "../../components/modals/HomePayFeeModalViewOnRamp";


// MODAL FORMS
export const HomeRepayCreditModalViewList = ({onCloseModal, setCurrentView, handleBack, creditLine}: cModalViewDrawCreditProps) => {
  return (
    [
      {
        id: "main",
        component:
          <HomeRepayCreditModalView
            onCloseModal={onCloseModal}
            onClickStablecoin={() => setCurrentView(1)}
            onClickRamp={() => setCurrentView(2)}
            creditLine={creditLine}
          />
      },
      {
        id: "stablecoin",
        component:
          <HomeRepayCreditModalViewStablecoin
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />,
      },
      {
        id: "on-ramp",
        component:
          <HomeRepayCreditModalViewOnRamp
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />
      },
    ]
  )
}

export const HomeDrawCreditModalViewList = ({onCloseModal, setCurrentView, handleBack, creditLine}: cModalViewDrawCreditProps) => {
  return (
    [
      {
        id: "main",
        component:
          <HomeDrawCreditModalView
            onCloseModal={onCloseModal}
            onClickStablecoin={() => setCurrentView(1)}
            onClickRamp={() => setCurrentView(2)}
            creditLine={creditLine}
          />
      },
      {
        id: "wallet",
        component:
          <HomeDrawCreditModalViewWallet
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />,
      },
      {
        id: "off-ramp",
        component:
          <HomeDrawCreditModalViewOffRamp
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />
      },
    ]
  )
}

export const HomePayFeeModalViewList = ({onCloseModal, setCurrentView, handleBack, creditLine}: cModalViewDrawCreditProps) => {
  return (
    [
      {
        id: "main",
        component:
          <HomePayFeeModalView
            onCloseModal={onCloseModal}
            onClickStablecoin={() => setCurrentView(1)}
            onClickRamp={() => setCurrentView(2)}
            creditLine={creditLine}
          />
      },
      {
        id: "stablecoin",
        component:
          <HomePayFeeModalViewStablecoin
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />,
      },
      {
        id: "on-ramp",
        component:
          <HomePayFeeModalViewOnRamp
            onCloseModal={onCloseModal}
            handleBack={handleBack}
            creditLine={creditLine}
          />
      },
    ]
  )
}

export const HomeTransactionTabList = [
  {
    id: "credit-transaction",
    name: "Credit transactions",
    filter: "credit-transactions"
  },
  {
    id: "repayments",
    name: "Repayments",
    filter: "repayments"
  },
]

